"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkMultiLoanProductAdvanceRateErrors = exports.validateAdvanceRateTreeConfigNames = exports.getInvalidNamesForAdvanceRateTree = exports.getInvalidNamesForModifierTrees = exports.checkReceivableAdvanceRateConfigFormulaErrors = exports.checkFormula = exports.ReceivableAdvanceRateMiscAvailableFieldConfigs = void 0;
const remeda_1 = require("remeda");
const common_1 = require("@finley-technologies/common");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const RequiredIntermediateFields_1 = require("../RequiredIntermediateFields");
exports.ReceivableAdvanceRateMiscAvailableFieldConfigs = {
    'concentrationLimitFields.eligibleExposureLessConcentrationLimitKickouts': {
        label: 'concentrationLimitFields.eligibleExposureLessConcentrationLimitKickouts',
        description: 'Eligible exposure less concentration limit kickouts',
    },
    'postProcessedFields.originalOwnerId': {
        label: 'postProcessedFields.originalOwnerId',
        description: 'OriginalOwnerId',
    },
    'postProcessedFields.normalizedExposure': {
        label: 'postProcessedFields.normalizedExposure',
        description: 'normalizedExposure',
    },
    'postProcessedFields.preassignmentCreditFacilityId': {
        label: 'postProcessedFields.preassignmentCreditFacilityId',
        description: 'preassignmentCreditFacilityId',
    },
    'postProcessedFields.performingExposure': {
        label: 'postProcessedFields.performingExposure',
        description: 'performingExposure',
    },
    'valuationFields.valuation': {
        label: 'valuationFields.valuation',
        description: 'valuation',
    },
    'valuationFields.valuationRate': {
        label: 'valuationFields.valuationRate',
        description: 'valuationRate',
    },
    'eligibilityFields.eligibleExposure': {
        label: 'eligibilityFields.eligibleExposure',
        description: 'eligibleExposure will be 0 if not isEligible, otherwise exposure',
    },
    'eligibilityFields.isEligible': {
        label: 'eligibilityFields.isEligible',
        description: 'isEligible',
    },
    'eligibilityFields.eligibilityKickout': {
        label: 'eligibilityFields.eligibilityKickout',
        description: 'eligibilityKickout will be 0 if isEligible, otherwise exposure',
    },
};
const ReceivableAdvanceMiscAvailableFields = Object.keys(exports.ReceivableAdvanceRateMiscAvailableFieldConfigs);
const checkReceivableAdvanceRateModifierNodes = ({ availableVariablesSet, node, }) => {
    const errorMessages = [];
    const isMatchError = (0, formula_engine_1.getFormulaErrors)(node.isMatch.formula, availableVariablesSet, formula_engine_1.fullValidFunctions);
    errorMessages.push(...isMatchError.errorMessages);
    const modifierFormulaError = (0, formula_engine_1.getFormulaErrors)(node.modifierFormula.formula, availableVariablesSet, formula_engine_1.fullValidFunctions);
    errorMessages.push(...modifierFormulaError.errorMessages);
    for (const child of node.children) {
        errorMessages.push(...checkReceivableAdvanceRateModifierNodes({
            availableVariablesSet,
            node: child,
        }));
    }
    return errorMessages;
};
const checkReceivableAdvanceRateNodes = ({ availableVariablesSet, node, }) => {
    const errorMessages = [];
    const rootIsMatchErrors = (0, formula_engine_1.getFormulaErrors)(node.isMatch.formula, availableVariablesSet, formula_engine_1.fullValidFunctions);
    errorMessages.push(...rootIsMatchErrors.errorMessages);
    const rootAdvanceRateErrors = (0, formula_engine_1.getFormulaErrors)(node.advanceRate.formula, availableVariablesSet, formula_engine_1.fullValidFunctions);
    errorMessages.push(...rootAdvanceRateErrors.errorMessages);
    for (const child of node.children) {
        errorMessages.push(...checkReceivableAdvanceRateNodes({
            availableVariablesSet,
            node: child,
        }));
    }
    return errorMessages;
};
const checkFormula = ({ formula, intermediateCalcs, baseFields, includeAdvanceRateVariable, concentrationLimitConfigs, }) => {
    const variableNames = [];
    baseFields.forEach(({ field }) => {
        variableNames.push(`baseFields.${field}`);
    });
    intermediateCalcs.forEach(({ field }) => {
        if (!RequiredIntermediateFields_1.RequiredIntermediateFieldNames.includes(field)) {
            variableNames.push(`dynamicIntermediateFields.${field}`);
        }
    });
    RequiredIntermediateFields_1.RequiredIntermediateFieldNames.forEach((key) => {
        variableNames.push(`requiredIntermediateFields.${key}`);
    });
    ReceivableAdvanceMiscAvailableFields.forEach((key) => {
        variableNames.push(key);
    });
    concentrationLimitConfigs.forEach((config) => {
        config.waiveConfigs.forEach((waiver) => {
            variableNames.push(`concentrationLimitWaivers.${config.propertyKey}.${waiver.reason}`);
        });
    });
    const allVariablesArray = (0, formula_engine_1.createVariablesWithRange)(variableNames);
    const availableVariablesSet = new Set(allVariablesArray);
    if (includeAdvanceRateVariable) {
        availableVariablesSet.add('advanceRate');
    }
    const errors = (0, formula_engine_1.getFormulaErrors)(formula, availableVariablesSet, formula_engine_1.fullValidFunctions);
    return errors.errorMessages;
};
exports.checkFormula = checkFormula;
/**
 * Receivable advance rate formulas can use variables from baseFields and intermediate calcs.
 * This functions checks for any missing dependencies found in receivable advance rate formulas.
 */
const checkReceivableAdvanceRateConfigFormulaErrors = ({ receivableAdvanceRateConfig, intermediateCalcs, baseFields, concentrationLimitConfigs, }) => {
    const variableNames = [];
    baseFields.forEach(({ field }) => {
        variableNames.push(`baseFields.${field}`);
    });
    intermediateCalcs.forEach(({ field }) => {
        if (!RequiredIntermediateFields_1.RequiredIntermediateFieldNames.includes(field)) {
            variableNames.push(`dynamicIntermediateFields.${field}`);
        }
    });
    RequiredIntermediateFields_1.RequiredIntermediateFieldNames.forEach((key) => {
        variableNames.push(`requiredIntermediateFields.${key}`);
    });
    ReceivableAdvanceMiscAvailableFields.forEach((key) => {
        variableNames.push(key);
    });
    // NOTE: this is not guaranteed to exist for every receivable, formulas MUST be authored
    // very defensively (use `IFERROR`) if referencing a concentrationLimitWaivers property
    concentrationLimitConfigs.forEach((config) => {
        config.waiveConfigs.forEach((waiver) => {
            variableNames.push(`concentrationLimitWaivers.${config.propertyKey}.${waiver.reason}`);
        });
    });
    const allVariablesArray = (0, formula_engine_1.createVariablesWithRange)(variableNames);
    const availableVariablesSet = new Set(allVariablesArray);
    let errorMessages = [];
    switch (receivableAdvanceRateConfig.type) {
        case 'formula': {
            const errors = (0, formula_engine_1.getFormulaErrors)(receivableAdvanceRateConfig.config.formula, availableVariablesSet, formula_engine_1.fullValidFunctions);
            errorMessages = errors.errorMessages;
            break;
        }
        case 'tree':
            errorMessages = checkReceivableAdvanceRateNodes({
                availableVariablesSet,
                node: receivableAdvanceRateConfig.root,
            });
            // modifiers take in `advanceRate` in addition to base fields & intermediate fields
            availableVariablesSet.add('advanceRate');
            for (const modifier of receivableAdvanceRateConfig.modifiers) {
                const errors = checkReceivableAdvanceRateModifierNodes({
                    availableVariablesSet,
                    node: modifier,
                });
                errorMessages.push(...errors);
            }
            break;
        default:
            (0, common_1.finleyAssertUnreachable)(receivableAdvanceRateConfig);
    }
    return errorMessages;
};
exports.checkReceivableAdvanceRateConfigFormulaErrors = checkReceivableAdvanceRateConfigFormulaErrors;
// We check duplicates at each level. Not overall.
// (e.g. fixedIncome -> AAA, fixedIncome -> AAA is invalid... but fixedIncome -> government -> AAA, fixedIncome -> city -> AAA is valid)
const getDuplicateModifierNodeNames = (node) => {
    const namesWithPoundSignOrRightArrow = [];
    const duplicates = [];
    const uniqueSetOfModifierNames = new Set();
    if (node.name.includes('#') || node.name.includes('>')) {
        namesWithPoundSignOrRightArrow.push(node.name);
    }
    for (const child of node.children) {
        if (uniqueSetOfModifierNames.has(child.name)) {
            duplicates.push(child.name);
        }
        else {
            uniqueSetOfModifierNames.add(child.name);
        }
        const result = getDuplicateModifierNodeNames(child);
        duplicates.push(...result.duplicates);
        namesWithPoundSignOrRightArrow.push(...result.namesWithPoundSignOrRightArrow);
    }
    return {
        duplicates: duplicates.map((d) => `${node.name}#${d}`),
        namesWithPoundSignOrRightArrow,
    };
};
const getInvalidNamesForModifierTrees = (modifierTrees) => {
    const uniqueModifierRootNames = new Set();
    const duplicateModifierNames = [];
    const namesWithPoundSignOrRightArrow = [];
    for (const modifierTree of modifierTrees) {
        if (modifierTree.name.includes('#') || modifierTree.name.includes('>')) {
            namesWithPoundSignOrRightArrow.push(modifierTree.name);
        }
        if (uniqueModifierRootNames.has(modifierTree.name)) {
            duplicateModifierNames.push(modifierTree.name);
        }
        else {
            uniqueModifierRootNames.add(modifierTree.name);
        }
        const result = getDuplicateModifierNodeNames(modifierTree);
        duplicateModifierNames.push(...result.duplicates);
        namesWithPoundSignOrRightArrow.push(...result.namesWithPoundSignOrRightArrow);
    }
    return { duplicateModifierNames, namesWithPoundSignOrRightArrow };
};
exports.getInvalidNamesForModifierTrees = getInvalidNamesForModifierTrees;
const getInvalidNamesForAdvanceRateTree = (node, validModifierNames) => {
    const incorrectModifierNames = [];
    for (const name of node.modifierNames) {
        if (!validModifierNames.has(name)) {
            incorrectModifierNames.push(name);
        }
    }
    const namesWithPoundSign = [];
    if (node.name.includes('#') || node.name.includes('>')) {
        namesWithPoundSign.push(node.name);
    }
    const duplicates = [];
    const uniqueSetOfNodeNames = new Set();
    for (const child of node.children) {
        if (uniqueSetOfNodeNames.has(child.name)) {
            duplicates.push(child.name);
        }
        else {
            uniqueSetOfNodeNames.add(child.name);
        }
        const result = (0, exports.getInvalidNamesForAdvanceRateTree)(child, validModifierNames);
        duplicates.push(...result.duplicates);
        incorrectModifierNames.push(...result.incorrectModifierNames);
        namesWithPoundSign.push(...result.namesWithPoundSign);
    }
    return {
        duplicates: duplicates.map((d) => `${node.name}#${d}`),
        incorrectModifierNames,
        namesWithPoundSign,
    };
};
exports.getInvalidNamesForAdvanceRateTree = getInvalidNamesForAdvanceRateTree;
const validateAdvanceRateTreeConfigNames = (treeConfig) => {
    const errors = [];
    // check if duplicate modifier names exist
    const invalidModiferNames = (0, exports.getInvalidNamesForModifierTrees)(treeConfig.modifiers);
    if (invalidModiferNames.duplicateModifierNames.length > 0) {
        const duplicateModifierNamesSet = new Set(invalidModiferNames.duplicateModifierNames);
        errors.push(`Receivable Advance Rate Config has duplicate modifier name(s): ${[
            ...duplicateModifierNamesSet,
        ].join(', ')}`);
    }
    if (invalidModiferNames.namesWithPoundSignOrRightArrow.length > 0) {
        const namesWithPoundSignOrRightArrowSet = new Set(invalidModiferNames.namesWithPoundSignOrRightArrow);
        errors.push(`Receivable Advance Rate Config Modifier names cannot contain '#' or '>' fix these: ${[
            ...namesWithPoundSignOrRightArrowSet,
        ].join(', ')}`);
    }
    // check node names & modifier names on advance rate tree
    const validModifierNames = new Set(treeConfig.modifiers.map((m) => m.name));
    const { duplicates, incorrectModifierNames, namesWithPoundSign, } = (0, exports.getInvalidNamesForAdvanceRateTree)(treeConfig.root, validModifierNames);
    if (duplicates.length > 0) {
        const duplicatesSet = new Set(duplicates);
        errors.push(`Receivable Advance Rate Config has duplicate advance rate node name(s): ${[
            ...duplicatesSet,
        ].join(', ')}`);
    }
    if (namesWithPoundSign.length > 0) {
        const namesWithPoundSignSet = new Set(namesWithPoundSign);
        errors.push(`Receivable Advance Rate Config names cannot contain '#' or '>' fix these: ${[
            ...namesWithPoundSignSet,
        ].join(', ')}`);
    }
    if (incorrectModifierNames.length > 0) {
        errors.push(`Receivable Advance Rate Config has incorrect modifier name(s): ${incorrectModifierNames}`);
    }
    return errors;
};
exports.validateAdvanceRateTreeConfigNames = validateAdvanceRateTreeConfigNames;
/**
 * Store available fields within a map by loan product for easy look up
 * in subsequent validations to assess uses (e.g., within formula)
 */
const _generateLoanProductFieldsMap = (params) => {
    const loanProductFullFieldsMap = new Map();
    for (const { _config_, loanProductId } of params.loanProducts) {
        const { baseFieldConfigs, intermediateCalcConfigs } = _config_;
        const fullFieldsArray = [];
        // Store "base fields" as available fields
        for (const { field, type } of baseFieldConfigs) {
            fullFieldsArray.push({ field: `baseFields.${field}`, type });
        }
        // Store dynamic "intermediate calcs" as available fields
        for (const { field, fieldType } of intermediateCalcConfigs) {
            if (!RequiredIntermediateFields_1.RequiredIntermediateFieldNames.includes(field)) {
                fullFieldsArray.push({
                    field: `dynamicIntermediateFields.${field}`,
                    type: fieldType,
                });
            }
        }
        // Store required "intermediate calcs" as available fields
        RequiredIntermediateFields_1.RequiredIntermediateFieldNames.forEach((field) => {
            fullFieldsArray.push({ field, type: undefined });
        });
        // Manage "valuation", "eligibility", "concentration", and "post-processing" fields
        ReceivableAdvanceMiscAvailableFields.forEach((field) => {
            fullFieldsArray.push({ field, type: undefined });
        });
        loanProductFullFieldsMap.set(loanProductId, fullFieldsArray);
    }
    return loanProductFullFieldsMap;
};
/**
 * Retrieve field structure based on available map and target fields.
 * If any are missing, return those as part of "errors" structure
 */
const _retrieveFieldsPerTargetForLoanProduct = (params) => {
    const { availableFieldsMap, loanProductId, targetFields } = params;
    const availableFields = availableFieldsMap.get(loanProductId);
    if (!availableFields) {
        (0, common_1.debugLog)({ availableFieldsMap });
        return {
            isValid: false,
            errors: [
                `Receivable Advance Rate Config: Failed to find fields for [loanProductId:${loanProductId}]`,
            ],
        };
    }
    const fields = [];
    const errors = [];
    for (const targetField of targetFields) {
        const foundField = availableFields.find(({ field }) => targetField === field);
        if (foundField) {
            fields.push(foundField);
        }
        else {
            errors.push(`Receivable Advance Rate Config: Failed to find [field:${targetField}] for [loanProductId:${loanProductId}]`);
        }
    }
    if (errors.length > 0) {
        return { isValid: false, errors };
    }
    return { isValid: true, fields };
};
/**
 * This validation checks field types are the same across each set (loanProduct)
 */
const _checkMatchingFieldsAttributes = (params) => {
    const { fieldsToCheck, existingFields } = params;
    const existingFieldsMap = (0, remeda_1.mapToObj)(existingFields, (field) => [
        field.field,
        field,
    ]);
    const newFields = [];
    const errors = [];
    for (const { field, type } of fieldsToCheck) {
        const targetField = existingFieldsMap[field];
        if (targetField) {
            if (type !== targetField.type) {
                errors.push(`Receivable Advance Rate Config: [field:${field}] has mismatched types [${type}, ${targetField.type}]`);
            }
        }
        else {
            newFields.push({ field, type });
        }
    }
    if (errors.length > 0) {
        return { isValid: false, errors };
    }
    return { isValid: true, newFields };
};
const checkMultiLoanProductAdvanceRateErrors = (borrowingBaseMechanics) => {
    const errors = [];
    const { loanProducts } = borrowingBaseMechanics;
    const availableFieldsMap = _generateLoanProductFieldsMap({ loanProducts });
    loanProducts.forEach(({ receivableAdvanceRateConfig }) => {
        if (receivableAdvanceRateConfig.type === 'formula') {
            const { formula } = receivableAdvanceRateConfig.config;
            // Only care about "ranged variables" as they're the only ones that are needed
            // across loan products come time of advance rate evaluation
            const { rangeVariables } = (0, formula_engine_1.getFormulaComposition)(formula);
            const targetFields = new Set();
            for (const variable of rangeVariables) {
                targetFields.add((0, formula_engine_1.extractVariableNameFromRange)(variable));
            }
            const existingFields = [];
            for (const loanProductId of receivableAdvanceRateConfig.loanProductIds) {
                // Ensure each loan product has the required fields
                const foundFields = _retrieveFieldsPerTargetForLoanProduct({
                    targetFields,
                    loanProductId,
                    availableFieldsMap,
                });
                if (!foundFields.isValid) {
                    for (const error of foundFields.errors) {
                        errors.push(error);
                    }
                    continue;
                }
                // Validate field type matches across loan products
                const checkFieldsResult = _checkMatchingFieldsAttributes({
                    fieldsToCheck: foundFields.fields,
                    existingFields,
                });
                if (!checkFieldsResult.isValid) {
                    for (const error of checkFieldsResult.errors) {
                        errors.push(error);
                    }
                    continue;
                }
                for (const field of checkFieldsResult.newFields) {
                    existingFields.push(field);
                }
            }
        }
    });
    return errors;
};
exports.checkMultiLoanProductAdvanceRateErrors = checkMultiLoanProductAdvanceRateErrors;
//# sourceMappingURL=advanceRateValidations.js.map